import * as React from 'react';

function SvgVisaColourSquare(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="VisaColourSquare_svg__a"
        maskUnits="userSpaceOnUse"
        x={20}
        y={10}
        width={9}
        height={9}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.31 10.207c-.548 0-.867.213-1.08.72l-2.947 7.03c-.138.328-.273.657-.416 1 .784 0 1.546.002 2.308-.004.04 0 .098-.064.116-.111.13-.344.258-.688.374-1.037.039-.116.09-.159.218-.158.845.007 1.69.01 2.535-.001.17-.002.218.056.245.208.066.366.148.728.225 1.099h2.108v-.062c-.068-.296-.141-.59-.203-.887-.485-2.315-.967-4.631-1.45-6.947l-.182-.85h-1.85zm.233 2.431l.027.005.668 3.202H24.38l1.163-3.207z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#VisaColourSquare_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.31 10.207c-.548 0-.867.213-1.08.72l-2.947 7.03c-.138.328-.273.657-.416 1 .784 0 1.546.002 2.308-.004.04 0 .098-.064.116-.111.13-.344.258-.688.374-1.037.039-.116.09-.159.218-.158.845.007 1.69.01 2.535-.001.17-.002.218.056.245.208.066.366.148.728.225 1.099h2.108v-.062c-.068-.296-.141-.59-.203-.887-.485-2.315-.967-4.631-1.45-6.947l-.182-.85h-1.85zm.233 2.431l.027.005.668 3.202H24.38l1.163-3.207z"
          fill="url(#VisaColourSquare_svg__paint0_linear)"
        />
      </g>
      <mask
        id="VisaColourSquare_svg__b"
        maskUnits="userSpaceOnUse"
        x={14}
        y={10}
        width={8}
        height={10}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.757 10.052c-.044.01-.087.025-.131.03-.796.097-1.543.327-2.172.844-.723.594-1.072 1.359-.971 2.3.068.63.425 1.103.917 1.458.385.277.816.488 1.222.735.26.158.535.304.763.502.347.3.31.78-.07 1.036-.177.118-.388.21-.595.248-.797.15-1.566.012-2.31-.288-.157-.063-.31-.134-.472-.205l-.408 1.911c.029.018.045.032.064.04.062.025.124.05.188.072a7.173 7.173 0 002.25.364h.004c.224 0 .448-.011.674-.032.715-.067 1.4-.246 2.006-.648.963-.64 1.388-1.543 1.245-2.69-.081-.648-.466-1.128-.994-1.476-.448-.297-.932-.538-1.393-.815a3.357 3.357 0 01-.578-.416c-.248-.234-.244-.554.016-.777.151-.13.346-.233.539-.287.473-.132.959-.092 1.432.013.346.076.683.195 1.035.298.13-.6.26-1.215.395-1.845-.267-.076-.513-.157-.764-.215-.276-.063-.556-.106-.834-.157h-1.058z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#VisaColourSquare_svg__b)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.757 10.052c-.044.01-.087.025-.131.03-.796.097-1.543.327-2.172.844-.723.594-1.072 1.359-.971 2.3.068.63.425 1.103.917 1.458.385.277.816.488 1.222.735.26.158.535.304.763.502.347.3.31.78-.07 1.036-.177.118-.388.21-.595.248-.797.15-1.566.012-2.31-.288-.157-.063-.31-.134-.472-.205l-.408 1.911c.029.018.045.032.064.04.062.025.124.05.188.072a7.173 7.173 0 002.25.364h.004c.224 0 .448-.011.674-.032.715-.067 1.4-.246 2.006-.648.963-.64 1.388-1.543 1.245-2.69-.081-.648-.466-1.128-.994-1.476-.448-.297-.932-.538-1.393-.815a3.357 3.357 0 01-.578-.416c-.248-.234-.244-.554.016-.777.151-.13.346-.233.539-.287.473-.132.959-.092 1.432.013.346.076.683.195 1.035.298.13-.6.26-1.215.395-1.845-.267-.076-.513-.157-.764-.215-.276-.063-.556-.106-.834-.157h-1.058z"
          fill="url(#VisaColourSquare_svg__paint1_linear)"
        />
      </g>
      <mask
        id="VisaColourSquare_svg__c"
        maskUnits="userSpaceOnUse"
        x={1}
        y={10}
        width={11}
        height={9}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.18 10.341c-.741 1.884-1.485 3.766-2.23 5.648-.014.036-.035.069-.066.127l-.049-.237c-.3-1.593-.598-3.186-.902-4.779-.107-.562-.517-.892-1.086-.893H1.253c-.25 0-.25 0-.253.263l.087.022c.671.159 1.329.355 1.962.634.395.174.606.458.711.873.574 2.263 1.164 4.522 1.745 6.784.033.13.08.181.226.18.684-.01 1.369-.008 2.053-.002.125 0 .188-.032.24-.155 1.08-2.59 2.166-5.176 3.25-7.764.115-.271.227-.543.345-.827-.064-.003-.109-.007-.153-.007h-.59c-.499 0-.997 0-1.496-.003h-.004c-.108 0-.157.035-.197.136z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#VisaColourSquare_svg__c)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.18 10.341c-.741 1.884-1.485 3.766-2.23 5.648-.014.036-.035.069-.066.127l-.049-.237c-.3-1.593-.598-3.186-.902-4.779-.107-.562-.517-.892-1.086-.893H1.253c-.25 0-.25 0-.253.263l.087.022c.671.159 1.329.355 1.962.634.395.174.606.458.711.873.574 2.263 1.164 4.522 1.745 6.784.033.13.08.181.226.18.684-.01 1.369-.008 2.053-.002.125 0 .188-.032.24-.155 1.08-2.59 2.166-5.176 3.25-7.764.115-.271.227-.543.345-.827-.064-.003-.109-.007-.153-.007h-.59c-.499 0-.997 0-1.496-.003h-.004c-.108 0-.157.035-.197.136z"
          fill="url(#VisaColourSquare_svg__paint2_linear)"
        />
      </g>
      <mask
        id="VisaColourSquare_svg__d"
        maskUnits="userSpaceOnUse"
        x={10}
        y={10}
        width={5}
        height={9}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.582 10.217l-1.87 8.741h.186c.622 0 1.245-.007 1.867.005.173.003.233-.05.268-.217.509-2.406 1.025-4.811 1.54-7.216l.279-1.313h-2.27z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#VisaColourSquare_svg__d)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.582 10.217l-1.87 8.741h.186c.622 0 1.245-.007 1.867.005.173.003.233-.05.268-.217.509-2.406 1.025-4.811 1.54-7.216l.279-1.313h-2.27z"
          fill="url(#VisaColourSquare_svg__paint3_linear)"
        />
      </g>
      <defs>
        <linearGradient
          id="VisaColourSquare_svg__paint0_linear"
          x1={2.647}
          y1={28.888}
          x2={28.93}
          y2={28.739}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#262860" />
          <stop offset={1} stopColor="#3D439A" />
        </linearGradient>
        <linearGradient
          id="VisaColourSquare_svg__paint1_linear"
          x1={2.633}
          y1={31.949}
          x2={28.915}
          y2={31.849}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#262860" />
          <stop offset={1} stopColor="#3D439A" />
        </linearGradient>
        <linearGradient
          id="VisaColourSquare_svg__paint2_linear"
          x1={2.671}
          y1={25.434}
          x2={28.952}
          y2={25.18}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#262860" />
          <stop offset={1} stopColor="#3D439A" />
        </linearGradient>
        <linearGradient
          id="VisaColourSquare_svg__paint3_linear"
          x1={2.607}
          y1={42.414}
          x2={28.89}
          y2={42.375}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#262860" />
          <stop offset={1} stopColor="#3D439A" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default SvgVisaColourSquare;
